

<div style="background-color: #1c2439; padding: 10px; margin-bottom: 1rem;">
  <div class="flex flex-column align-items-center justify-content-center mb-4">
    <img class="logo" src="/assets/images/logo-guai.png" width="120">
    <!--<b class="company-name">GUAI Insurtech</b>-->
  </div>
</div>

<div class="m-4">
  <p-card styleClass="info">
    <ng-template pTemplate="header">
      <div class="flex justify-content-center pb-0 gap-2">
        <div style="width: 150px;">
          <button pButton label="Volver" icon="pi pi-arrow-left" class="p-button-text" (click)="goBack()"></button>
        </div>
        <div class="flex-grow-1 flex justify-content-center">
          <div class="p-card-title">Condiciones de venta</div>
        </div>
        <div style="width: 150px;"></div>
      </div>
    </ng-template>
    <div class="flex flex-column">
        
    </div>
  </p-card>
</div>


<div class="mt-4 p-4 flex gap-2 justify-content-center">
  <a href="/public/legal/{{business?.id}}/info">Aviso legal</a>
  <a href="/public/legal/{{business?.id}}/terms">Condiciones de venta</a>
</div>